<template>
  <div class="variety-grid-template">
    <GridPanelHeader :show-add="true" :show-filter="false" :show-export="false" :show-columns="false" @add="onAddVariety" />
    <DxDataGrid ref="vgrid" :data-source="dataSource" :show-borders="true" :remote-operations="gridRemoteOperations">
      <DxColumn dataField="name" :caption="$t('works.cultures.variety_name')" :filter-operations="['contains']">
        <DxRequiredRule :message="$t('validation.name_is_required')" />
      </DxColumn>
      <DxColumn dataField="display_name" :caption="$t('display_name')" :width="'20%'" :filter-operations="['contains']" />
      <DxColumn
        dataField="created_at"
        :caption="$t('common.created_at')"
        dataType="date"
        format="yyyy-MM-dd"
        alignment="center"
        :filter-operations="['=']"
        :formItem="{
          visible: false,
        }"
      />

      <DxColumn
        dataField="updated_at"
        :caption="$t('common.updated_at')"
        dataType="date"
        format="yyyy-MM-dd"
        alignment="center"
        :filter-operations="['=']"
        :formItem="{
          visible: false,
        }"
      />
      <DxFilterRow :visible="true" />
      <DxEditing :allow-adding="false" :allow-updating="true" :allow-deleting="true" mode="form" :use-icons="true">
        <DxTexts
          :confirm-delete-message="$t('works.cultures.messages.confirm_delete_variety')"
          :confirm-delete-title="$t('common.confirm_delete_title')"
        />
      </DxEditing>
    </DxDataGrid>
  </div>
</template>

<script>
import GridPanelHeader from "@/components/DxGrid/GridPanelHeader.vue";
import DxDataGrid, { DxColumn, DxEditing, DxFilterRow, DxRequiredRule, DxTexts } from "devextreme-vue/data-grid";
import { mapActions } from "vuex";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";

export default {
  name: "VarietyGridTemplate",
  props: {
    data: Object,
  },
  components: {
    GridPanelHeader,
    DxFilterRow,
    DxRequiredRule,
    DxTexts,
    DxEditing,
    DxColumn,
    DxDataGrid,
  },
  data() {
    return {
      gridRemoteOperations: {
        filtering: false,
        sorting: false,
      },
    };
  },
  computed: {
    dataSource() {
      return new DataSource({
        store: new CustomStore({
          key: "uuid",
          load: this.load,
          insert: this.insert,
          update: this.update,
          remove: this.remove,
        }),
      });
    },
  },
  methods: {
    onAddVariety() {
      this.$refs.vgrid.instance.addRow();
    },
    ...mapActions({
      get: "works-cultures/getCultureVarieties",
      create: "works-cultures/createCultureVariety",
      change: "works-cultures/updateCultureVariety",
      delete: "works-cultures/deleteCultureVariety",
    }),
    async load(data) {
      return await this.get({
        culture_uuid: this.data.uuid,
        filter: data.filter,
        sort: data.sort,
        limit: 9999,
        enablePagination: 0,
      });
    },
    async insert(data) {
      await this.create(
        Object.assign({}, data, {
          culture_uuid: this.data.uuid,
        }),
      );
    },
    async update(key, obj) {
      const updatable = Object.assign(
        {},
        this.dataSource.items().find((item) => item.uuid === key),
        obj,
      );
      await this.change(
        Object.assign({}, updatable, {
          culture_uuid: this.data.uuid,
        }),
      );
    },
    remove(uuid) {
      this.delete({
        uuid: uuid,
      });
    },
  },
};
</script>
<style scoped>
.variety-grid-template {
  margin-top: 20px;
}
</style>
